/**
 * @file  图片操作
 * @author liudy
 */
import Api from '../../../path';
import { fetchData } from '@umu/umu-fetch';

export interface IInput {
    element_id: number;
    photo_id: string;
    action_type: 'top' | 'un_top' | 'del' | 'shield'; // top ｜ 置顶  del ｜ 删除 shield ｜ 屏蔽
}

export interface IOutput {
    status: number;
    message: string;
}

export const setPhoto = (data: IInput): Promise<IResponse<IOutput>> => {
    return fetchData(Api.PHOTO_SET_PHOTO, data).then((res: IResponse<IOutput>) => {
        return res;
    });
};
